const ROOT = "containers/AddressVoiceSearch/"

export const REQUEST = ROOT + "REQUEST"
export const RECEIVE = ROOT + "RECEIVE"
